export const PRODUCTION_HOSTNAME = 'www.codi.com';
export const STAGING_HOSTNAME = 'staging.codi.com';
export const DEVELOP_HOSTNAMES = ['localhost', '127.0.0.1'];

export const PRODUCTION_URL = `https://${PRODUCTION_HOSTNAME}` as const;
export const STAGING_URL = `https://${STAGING_HOSTNAME}` as const;
export const DEVELOP_URL = 'http://localhost:3006' as const;
